import { gql } from '../__generated__';

export const GET_CHURN = gql(`
  query GetChurn($fromDate: DateTimeOffset!, $toDate: DateTimeOffset, $invoiceMonth: Int, $type: ChurnType, $actions: ChurnAction) {
    model: getChurn(fromDate: $fromDate, toDate: $toDate, invoiceMonth: $invoiceMonth, type: $type, actions: $actions) {
      bfsAll {
        timestamp
        value
      }
      bfs {
        timestamp
        value
      }
      bfsp {
        timestamp
        value
      }
      bfsb {
        timestamp
        value
      }
      bfsf {
        timestamp
        value
      }
      bfsu {
        timestamp
        value
      }
      bvn {
        timestamp
        value
      }
    }
  }
`);

export const GET_TERMINATION = gql(`
  query GetTermination($fromDate: DateTimeOffset!, $toDate: DateTimeOffset) {
    model: getTermination(fromDate: $fromDate, toDate: $toDate) {
      licenseUserName
      licenseSubscriptions
      terminationRequestedDate
      terminationReason
      id
    }
  }
`);

export const GET_GUIDES = gql(`
  query GetGuides($page: Int = 1, $pageSize: Int = 100, $searchTerm: String) {
    allGuides(page: $page, pageSize: $pageSize, searchTerm: $searchTerm) {
      guides {
        docId
        docName
        title
        versions {
          versionId
          guideVersionId
          versionNumber
          status
          isActive
        }
      }
      totalCount
      page
      pageSize
    }
  }
`);

export const GET_USER_OCCUPATION = gql(`
  query GetUserOccupation {
    userOccupation: getUserByOccupation {
      id
      occupation
      company
      email
    }
  }
`);

export const GET_BUSINESS_CODE = gql(`
  query GetBusinessCode($filterOption: String) {
    businesses: getBusinessCode(filterOption: $filterOption) {
      code
      companyCount
      description
      licenseCount
      userCount
    }
  }
`);

export const GET_LICENSE_BY_GUIDE = gql(`
  query GetLicenseByGuide($guideId: Int!, $fromDate: DateTimeOffset!, $toDate: DateTimeOffset) {
    customers: getLicenseByGuide(guideId: $guideId, fromDate: $fromDate, toDate: $toDate) {
      customerId
      name
      count
      email
      phoneNumber
      downloads {
        count
        type
      }
    }
  }
`);

export const GET_EMPLOYEE = gql(`
  query GetEmployee($code: String, $filterOption: String) {
    employees: getEmployeeByBusinessCode(code: $code, filterOption: $filterOption) {
      key
      companyCount
      licenseCount
      userCount
    }
  }
`);

export const GET_EMPLOYEE_ALL = gql(`
  query GetEmployeeAll($noCodeFilterOption: String) {
    employees: getEmployeeAll(filterOption: $noCodeFilterOption) {
      key
      companyCount
      licenseCount
    }
  }
`);

export const GET_INCORP_YEAR_ALL = gql(`
  query GetIncorpYearAll($noCodeFilterOption: String) {
    incorporationscomp: getIncorporationYearAll(filterOption: $noCodeFilterOption) {
      key
      companyCount
      licenseCount
    }
  }
`);

export const GET_COMPANIES = gql(`
  query GetCompanies {
    companyOverview: getCompanies {
      orgNumber
      companyName
      brreg
      licenseCount
      userCount
    }
  }
`);

export const GET_DOCUMENT_VIEWS_PER_ORG = gql(`
  query GetDocumentViewsPerOrg($orgNumber: String!, $fromDate: String, $toDate: String) {
    docViews: getDocViewsPerCompany(orgNumber: $orgNumber, fromDate: $fromDate, toDate: $toDate) {
      docNumber
      title
      views
      seriesId
      sourceId
      docId
    }
  }
`);

export const GET_DOCUMENT_VIEWS_PER_COMPANY_USER = gql(`
  query GetDocViewsPerCompanyUser($orgNumber: String!, $fromDate: String, $toDate: String, $productType: String) {
    docViewsPerCompanyUser: getDocViewsPerCompanyUser(orgNumber: $orgNumber, fromDate: $fromDate, toDate: $toDate, productType: $productType) {
      userId
      firstName
      lastName
      views
      seriesId
      sourceId
    }
  }
`);

export const GET_DOWNLOADS_PER_COMPANY_USER = gql(`
  query GetDownloadsPerCompanyUser($orgNumber: String!, $fromDate: String, $toDate: String, $productType: String) {
    downloadsPerCompanyUser: getDownloadsPerCompanyUser(orgNumber: $orgNumber, fromDate: $fromDate, toDate: $toDate, productType: $productType) {
      userId
      firstName
      lastName
      downloads
      seriesId
      sourceId
    }
  }
`);

export const GET_COMPANY = gql(`
  query GetCompany($employeeRange: String, $code: String, $filterOption: String) {
    companies: getCompanyByCodeAndRange(employeeRange: $employeeRange, code: $code, filterOption: $filterOption) {
      companyName
      orgNumber
      maconomyCustomerNumber
      admin
      createDate
      code
      codeDescription
      userCount
    }
  }
`);

export const GET_COMPANY_ALL = gql(`
  query GetCompanyAll($employeeRange: String, $noCodeFilterOption: String) {
    companies: getCompanyByEmployeeRange(employeeRange: $employeeRange, filterOption: $noCodeFilterOption) {
      companyName
      orgNumber
      maconomyCustomerNumber
      admin
      createDate
      code
      codeDescription
    }
  }
`);

export const GET_INCORP_YEAR_DETAIL_ALL = gql(`
  query GetIncorpYearDetailAll($incorporationYearRange: String, $noCodeFilterOption: String) {
    inccompanies: getCompanyByIncorporationYearRange(incorporationYearRange: $incorporationYearRange, filterOption: $noCodeFilterOption) {
      companyName
      orgNumber
      maconomyCustomerNumber
      admin
      incorporationDate
      code
      codeDescription
    }
  }
`);

export const GET_USELOG_BY_LICENSE = gql(`
  query GetUselogByLicense($licenseId: Int!, $guideId: Int!, $fromDate: DateTimeOffset!, $toDate: DateTimeOffset, $email: String) {
    uselogs: getUseLogByLicense(licenseId: $licenseId, guideId: $guideId, fromDate: $fromDate, toDate: $toDate, email: $email) {
      numberOfVisit
      userId
      firstName
      lastName
      email
      medium
      displayName
    }
  }
`);

export const GET_LICENSES_WITH_HIGH_USAGE = gql(`
  query GetLicensesWithHighUsage($monthOffset: Int!, $take: Int!) {
    licenses: getLicensesWithHighUsage(monthOffset: $monthOffset, take: $take) {
      licenseId
      companyName
      orgNumber
      views
    }
  }
`);

export const GET_USERS_WITH_HIGH_USAGE = gql(`
  query GetUsersWithHighUsage($monthOffset: Int!, $take: Int!) {
    users: getUsersWithHighUsage(monthOffset: $monthOffset, take: $take) {
      userId
      name
      licenseId
      companyName
      views
    }
  }
`);

export const GET_TRIAL_CONVERSION_REPORT = gql(`
  query GetTrialConversionReport(
    $fromDate: DateTimeOffset!
    $toDate: DateTimeOffset!
    $defaultTrialLicenseId: Int!
    $trialLicenseId: Int
    $subscriptionIds: [Int!]!
  ) {
    model: getTrialConversionReport(
      fromDate: $fromDate
      toDate: $toDate
      defaultTrialLicenseId: $defaultTrialLicenseId
      trialLicenseId: $trialLicenseId
      subscriptionIds: $subscriptionIds
    ) {
      totalTrialUsersInPeriod
      trialUsersWithPaidSubscription
      trialUsersWithSingleDocumentAccess
      trialUsersWithBoth
      trialUsersWithAnyPurchase
      convertedUsers {
        email
        trialCreatedAt
        trialLicenseId
        trialLicenseName
        trialSubscriptionId
        trialSubscriptionName
        convertedAt
        convertedLicenseId
        convertedLicenseName
        totalAmountPaid
        convertedSubscriptionId
        convertedSubscriptionName
        conversionType
        title
      }
    }
  }
`);
